<template>
  <div>
    <div class="container text-left">
      <div class="row">
        <div
          v-if="
            $canManageAccount(
              $store.getters.user.Permissions,
              account.Account_Id
            )
          "
          class="col-auto"
        >
          <p style="visibility:hidden;">$</p>
          <i
            class="material-icons d-block pointer mt-1"
            v-on:click="editAccount"
          >
            edit
          </i>
        </div>
        <div class="col">
          <p class="text-secondary">Billing</p>
          <p class="mb-1">{{ account.Billing_Name }}</p>
          <p class="mb-1">{{ account.Billing_Address_Line_1 }}</p>
          <p class="mb-1">{{ account.Billing_Address_Line_2 }}</p>
          <p class="mb-1">
            {{ account.Billing_City }}, {{ account.Billing_State.Name }},
            {{ account.Billing_Zip }}
          </p>
          <p class="mb-1">{{ account.Billing_Phone }}</p>
        </div>
        <div class="col">
          <p class="text-secondary">Account Type</p>
          <p class="mb-1" v-if="account.Account_Type">
            {{ account.Account_Type.Title }}
          </p>
        </div>
        <div class="col">
          <p class="text-secondary">Payment</p>
          <p class="mb-1" v-if="account.Billing_Method">
            {{ account.Billing_Method.Title }}
          </p>
        </div>
      </div>

      <ManageOrganizationDetails
        v-bind:AccountId="account.Account_Id"
        v-bind:AccountVariables="AccountVariables"
        v-bind:Organizations="account.Organizations"
        v-bind:AccountType="account.Account_Type"
        v-bind:Permissions="Permissions"
        @manage-organization-permissions="manageOrganizationPermissions"
      />
    </div>

    <!--<EditAccountUserModal
      v-if="account.Organizations != undefined"
      v-bind:UserToEdit="userToEdit"
      v-bind:Organizations="
        account.Organizations.filter(o => o.Parent_Organization_Id != null)
      "
      @edited-user="userEdited"
    />-->
  </div>
</template>

<script>
import ManageOrganizationDetails from "@/components/Organization/ManageOrganizationDetails.vue";

/*import CreateAccountModal from "@/modals/ManageAccounts/CreateAccountModal.vue";
import EditAccountUserModal from "@/modals/ManageAccounts/EditAccountUserModal";*/
import $ from "jquery";

export default {
  name: "ManageAccountDetails",
  data() {
    return {
      account: this.Account,
      organizationTypes: [],
      accountToEdit: null,
      accountGroupId: "-1"
    };
  },
  props: {
    Account: Object,
    Permissions: Array,
    AccountVariables: Object
  },
  components: {
    ManageOrganizationDetails
  },
  created() {},
  async mounted() {
    var view = this;
    view.account = view.Account;
  },
  methods: {
    editAccount() {
      this.accountToEdit = this.account;
      $("#createAccountModal").modal("show");
    },
    accountEdited(editedAccount) {
      this.account = editedAccount;
    },
    editAccountClosed() {
      this.accountToEdit = null;
    },
    manageOrganizationPermissions(organization) {
      this.$emit("manage-organization-permissions", organization);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
